<sc-flex vertical fitHeight stretchContent class="no-field-space change-catalog-title-dialog">
    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="erp.ui.edit-catalog.title"></sc-dictionary-label>
    </sc-dialog-title>

    <sc-padding>
        <div style="width: 450px;">
            <sc-dictionary-field class="name-input" [model]="name" [maxlength]="255" defaultLabel="Name"
                labelDictionaryKey="erp.entity.catalog.name" (dictionaryChanged)="onNameChanged($event)">
            </sc-dictionary-field>
        </div>
    </sc-padding>

    <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          <sc-dictionary-label dictionaryKey="erp.ui.edit-catalog.action.cancel"></sc-dictionary-label>
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled()">
          <sc-dictionary-label dictionaryKey="erp.ui.add-catalog.action.confirm"></sc-dictionary-label>
        </button>
    </sc-actionbar>
</sc-flex>
